import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../containers/PageBuilder/Field';
import SectionContainer from '../../containers/PageBuilder/SectionBuilder/SectionContainer';
import { NamedLink } from '../../components';

import { parsePlan } from '../contentBits';
import { VISIBILITY_DELAY_HOURS } from '../membership';
import gem from '../salesPage.module.css';
import css from '../planCards.module.css';

/**
 * FairwayBid: Die Mitgliedschaften als Kacheln.
 *
 * Der Inhalt bleibt vollständig in der Console – Name, Preis, Beschreibung
 * und Leistungen stehen dort als Markdown. Hier wird er nur zerlegt und
 * gestaltet. Wer einen vierten Block anlegt, bekommt eine vierte Kachel.
 *
 * Hervorgehoben wird der mittlere: Eine Reihe aus drei gleichen Kästen
 * überlässt die Entscheidung dem Zufall, und das mittlere Paket ist das,
 * für das die meisten Händler sich entscheiden sollen.
 */
/**
 * Wann sieht dieses Paket eine neue Anfrage?
 *
 * Der Zeitvorsprung ist das eigentliche Kaufargument, steht aber nicht in
 * den Console-Texten - er ist eine Produkteigenschaft und wird deshalb aus
 * membership.js gelesen. Dieselbe Quelle, aus der auch das Portal rechnet:
 * Was hier steht, gilt auch, wenn ein Haendler angemeldet ist.
 *
 * Passt der Name nicht zu einem bekannten Paket, steht dort nichts - lieber
 * keine Angabe als eine erfundene.
 */
const sichtbarkeit = name => {
  const stunden = VISIBILITY_DELAY_HOURS[String(name || '').toLowerCase()];
  if (stunden === undefined) {
    return null;
  }
  return stunden === 0 ? 'Neue Anfragen sofort sichtbar' : `Neue Anfragen nach ${stunden} Stunden`;
};

const SectionPlanCards = props => {
  const {
    sectionId,
    className,
    rootClassName,
    title,
    description,
    appearance,
    callToAction,
    blocks = [],
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  const plaene = blocks.map(b => parsePlan(b?.title?.content, b?.text?.content));
  const mitte = plaene.length === 3 ? 1 : -1;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={gem.header}>
          <Field data={title} className={gem.headTitle} options={fieldOptions} />
          <span className={gem.rule} aria-hidden="true" />
          <Field data={description} className={gem.intro} options={fieldOptions} />
        </header>
      ) : null}

      <div className={gem.wrap}>
        <div className={css.plans}>
          {plaene.map((plan, i) => {
            const hervor = i === mitte;
            return (
              <article
                key={plan.name}
                className={classNames(css.plan, { [css.planFeatured]: hervor })}
              >
                {hervor ? <span className={css.planFlag}>Empfohlen</span> : null}
                <h3 className={css.planName}>{plan.name}</h3>
                {plan.preis ? <p className={css.planPrice}>{plan.preis}</p> : null}
                {plan.tagline ? <p className={css.planTagline}>{plan.tagline}</p> : null}
                {sichtbarkeit(plan.name) ? (
                  <p className={css.planTiming}>
                    <svg
                      className={css.clock}
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <circle
                        cx="7.5"
                        cy="7.5"
                        r="6"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.4"
                      />
                      <path
                        d="M7.5 4.2V7.7l2.4 1.6"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {sichtbarkeit(plan.name)}
                  </p>
                ) : null}
                {plan.umfang ? <p className={css.planScope}>{plan.umfang}</p> : null}
                <ul className={css.planList}>
                  {plan.punkte.map(p => (
                    <li key={p} className={css.planPoint}>
                      {p}
                    </li>
                  ))}
                </ul>
                <NamedLink
                  name="SignupPage"
                  className={classNames(css.planCta, { [css.planCtaFeatured]: hervor })}
                >
                  {plan.preis && plan.preis.startsWith('0 ')
                    ? 'Kostenlos starten'
                    : `Mit ${plan.name} starten`}
                </NamedLink>
              </article>
            );
          })}
        </div>
      </div>
    </SectionContainer>
  );
};

export default SectionPlanCards;
